import { render } from "./options.vue?vue&type=template&id=2a580512&scoped=true"
import script from "./options.vue?vue&type=script&lang=js"
export * from "./options.vue?vue&type=script&lang=js"

import "./options.vue?vue&type=style&index=0&id=2a580512&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a580512"]])

export default __exports__